import { Button, InfoBar } from "@shapr3d/frontend-lib";

import { useTracker } from "../../../../hooks/useTracker";
import { useChargebee } from "../../../../lib/ChargebeeAdapter";
import { ElementClickAction } from "../../../../lib/TrackingAdapter";
import { formatDueOnDate } from "../../../../utils/convertUtils";
import { mapChargebeeErrorMessages } from "../../ChargebeeCheckoutSchema";
import { useCheckoutFormContext } from "../CheckoutFormProvider";
import CouponInput from "../CouponInput/CouponInput";
import MigrationConsent from "../MigrationConsent/MigrationConsent";
import { PriceSummary } from "../PriceSummary/PriceSummary";

import style from "./CheckoutSummary.module.css";

export default function CheckoutSummary() {
  const { isLoading } = useChargebee();

  const { submitError, methods, estimateMutationResult, checkout, isMigrationConsentRequired } =
    useCheckoutFormContext();
  const isSubmitting = methods?.formState?.isSubmitting;

  const tracker = useTracker();

  const { data: estimateData, isPending: isEstimatePending } = estimateMutationResult ?? {};

  const isDiscountApplied =
    estimateData?.estimate?.discountAmount !== undefined &&
    Number.parseFloat(estimateData?.estimate.discountAmount) > 0;

  const submitErrorMessage = submitError ? mapChargebeeErrorMessages(submitError) : undefined;

  const trialEnd = estimateData?.estimate?.trialEnd ?? checkout?.trialEnd;

  return (
    <div className={style.summary}>
      <div className={style.horizontalLine} />

      <PriceSummary />

      <CouponInput isDiscountApplied={isDiscountApplied} />
      {isMigrationConsentRequired && <MigrationConsent />}
      <Button
        type="submit"
        disabled={isLoading || isSubmitting || isEstimatePending}
        className={style.submitButton}
        onClick={() => {
          tracker.trackButtonClick({
            elementId: "submit_checkout_form",
            action: trialEnd
              ? ElementClickAction.SUBMIT_CHECKOUT_FORM_TRIAL
              : ElementClickAction.SUBMIT_CHECKOUT_FORM,
            details: "chargebee",
          });
        }}
      >
        {trialEnd ? "Start Free Trial" : "Subscribe now"}
      </Button>

      {submitErrorMessage && (
        <InfoBar
          className={style.errorBox}
          title={submitErrorMessage.title}
          text={`${submitErrorMessage.description}`}
          variant="critical"
        ></InfoBar>
      )}

      {!isEstimatePending && estimateData && (
        <div className={style.footNote}>
          {!trialEnd && (
            <>
              <span>Your card will be charged when you click Subscribe now.</span>
              <br />
            </>
          )}
          {trialEnd && <span>{`Your trial ends on ${formatDueOnDate(trialEnd)}. `}</span>}
          {estimateData.estimate.amountWithSubscriptionMigration && (
            <span>{`All seats renew at full price. `}</span>
          )}
          <span>{`You will be charged ${estimateData.estimate.period} unless you cancel your subscription. `}</span>
          {estimateData.estimate.currencyCode === "USD" && (
            <span>{`All prices in ${estimateData.estimate.currencyCode}.`}</span>
          )}
        </div>
      )}
    </div>
  );
}
